module.exports = __webpack_public_path__ + "static/media/boronz_medal.cf19b0c2.png";